import { Reducer } from "redux";
import { Action, ActionType } from "../actionTypes/finalPLEvaluationTypes";

export interface IFinalPLEvaluationState {
  finalPLEvaluationDetailsByPID: any[];
}

const initialState = {
  finalPLEvaluationDetailsByPID: [],
};

export interface Iheaders {
  headName: string;
  value: string;
  classname?: string;
  separator?: string;
}
export interface ITableData {
  headers: Iheaders[];
  tableData: any;
  totalObject: Record<string, any>[];
}

export const finalPLEvaluationReducer: Reducer<IFinalPLEvaluationState, Action> = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.FINAL_PL_EVALUATION_DETAILS_BY_PID:
      return {
        ...state,
        finalPLEvaluationDetailsByPID: action.payload,
      };
    default:
      return state;
  }
};
